/**
 * Button Control Group Constants
 *
 * Constants and configuration for the button control group component.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { __ } from '@wordpress/i18n';

import type { ButtonEnabledControls } from './types';

/**
 * Default enabled controls configuration
 */
export const DEFAULT_BUTTON_ENABLED_CONTROLS: ButtonEnabledControls = {
	backgroundColor: true,
	textColor: true,
	responsive: true,
};

/**
 * Button control labels
 */
export const BUTTON_CONTROL_LABELS = {
	backgroundColor: __( 'Background Color', 'redfox-thank-you' ),
	textColor: __( 'Text Color', 'redfox-thank-you' ),
	reset: __( 'Reset Button', 'redfox-thank-you' ),
	resetAll: __( 'Reset All', 'redfox-thank-you' ),
};
